import React, { useState, useContext, useEffect } from 'react'
import AuthContext from '../auth/auth-context'
import { DashboardProvider } from './dashboard-context'
import { IOrganization } from './dashboard.interface'
import Header from '../header'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { roleList } from '../roles-helper'
import BackButton from '../dashboard/back-button'
import api from '../../api'
import jwtDecode from 'jwt-decode';

const BaseAccountLayout: React.FC = () => {
  const location = useLocation()
  const [activeIndex, setActiveIndex] = useState('')
  const orgArray: Array<IOrganization> = []
  const [organizationList, setOrganizationList] = useState(orgArray)
  const [selectedOrganization, setSelectedOrganization] = useState({
    name: '',
    id: '',
    roles: [''],
    orgNr: '',
  })

  const { token, setToken, setTokenData } = useContext(AuthContext)

  const getData = async () => {
    const decodedToken = jwtDecode(token)
    try {
      const res = await api.get(`/users/${decodedToken.sub}/accounts`)
      const accounts = res.data

      setTokenData({
        ...decodedToken,
        accounts,
      })

      if (!accounts.data) {
        await handleLogout()
      }

      await getOrganizationNumber(accounts.data)
      setOrganizationList(accounts.data)
    } catch (e) {
      console.log(e)
    }
  }

  const getOrganizationNumber = async (organizations) => {
    for (const organization of organizations) {
      try {
        const res = await api.get(`/accounts/${organization.id}/account-orgnr`)
        organization['orgNr'] = res.data.data.orgNr
      } catch (e) {
        organization['orgNr'] = ''
      }
    }
  }

  useEffect(() => {
    getData()
  }, [])

  useEffect(() => {
    if ((!selectedOrganization || selectedOrganization.id === '') && organizationList) {
      setSelectedOrganization(organizationList[0]) //TODO change back
    }
  }, [organizationList])

  const handleLogout = async () => {
    await api.get('/users/revoke-refresh-token').finally(() => {
      setToken('')
    })
  }

  const handleSelectedOrganization = (selectedName: string) => {
    const selected = organizationList.find((element) => element.name === selectedName)

    if (selected) {
      setSelectedOrganization(selected)
    } else if (organizationList) {
      setSelectedOrganization(organizationList[0])
    }
  }

  const ProtectedRoute = ({ children }) => {
    let includes = false
    const roles = selectedOrganization?.roles
    if (roles && roleList) {
      const path = roleList.find((role) => role.path === location.pathname)

      if (path && path.allowedAccess) {
        if (path.allowedAccess.includes('all')) {
          includes = true
        }

        roles.forEach((role) => {
          if (path.allowedAccess.includes(role)) {
            includes = true
          }
        })
      }
    }

    if (includes) {
      return children
    }

    return <Navigate to="/" replace />
  }

  return (
    <DashboardProvider
      value={{
        organizationList,
        activeIndex,
        setActiveIndex,
        setOrganizationList,
        selectedOrganization,
        setSelectedOrganization,
      }}
    >
      <Header
        organizationList={organizationList}
        selectedOrganization={selectedOrganization}
        handleLogout={handleLogout}
        handleSelectedOrganization={handleSelectedOrganization}
      />
      {location.pathname !== '/' && <BackButton />}

      <div className="container pt-12 mx-auto px-2 md:px-0 mb-10">
        {selectedOrganization?.id && selectedOrganization?.roles?.length > 0 && (
          <ProtectedRoute>
            <Outlet
              context={{
                selectedOrganization: [selectedOrganization, setSelectedOrganization],
              }}
            />
          </ProtectedRoute>
        )}
      </div>
      {/* <Footer /> */}
    </DashboardProvider>
  )
}

export default BaseAccountLayout
